(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ella-account-access"] && !Shopify.designMode) return;
  try {
    (function(){
  var dialog=document.getElementById('EllaAccountAccess');
  if(!dialog||dialog.dataset.ready)return;
  dialog.dataset.ready='true';
  var opener=null;
  document.addEventListener('click',function(event){
    var trigger=event.target.closest('[data-ella-account-open]');
    if(trigger){
      event.preventDefault();
      event.stopPropagation();
      opener=trigger;
      if(!dialog.open)dialog.showModal();
      return;
    }
    if(event.target.closest('[data-ella-account-close]'))dialog.close();
    if(event.target===dialog){
      var box=dialog.getBoundingClientRect();
      if(event.clientX<box.left||event.clientX>box.right||event.clientY<box.top||event.clientY>box.bottom)dialog.close();
    }
  },true);
  dialog.addEventListener('close',function(){if(opener)opener.focus();});
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ella-category-drawer"] && !Shopify.designMode) return;
  try {
    (() => {
  let opener;
  let previousOverflow;
  const getDrawer = () => document.getElementById('EllaCategoryDrawer');
  const showPanel = (drawer, id, focus) => {
    const panels = Array.from(drawer.querySelectorAll('.ella-drawer-panel'));
    const active = panels.find(panel => panel.id === id);
    if (!active) return;
    panels.forEach(panel => { panel.hidden = panel !== active; });
    drawer.querySelectorAll('[data-panel]').forEach(button => button.setAttribute('aria-expanded', String(button.dataset.panel === id)));
    drawer.querySelector('#EllaDrawerHeading').textContent = active.dataset.heading;
    const back = drawer.querySelector('.ella-drawer-back');
    back.hidden = !active.dataset.parent;
    back.dataset.panel = active.dataset.parent || '';
    drawer.querySelector('.ella-drawer-content').scrollTop = 0;
    if (focus) (back.hidden ? drawer.querySelector('.ella-drawer-close') : back).focus();
  };
  window.addEventListener('click', event => {
    const trigger = event.target.closest('.mobile-nav-trigger');
    const drawer = getDrawer();
    const cookieLink = event.target.closest('[data-ella-cookie-settings]');
    if (cookieLink) {
      const widget = document.querySelector('pandectes-cmp')?.shadowRoot?.querySelector('button.widget');
      if (widget) {
        event.preventDefault();
        event.stopImmediatePropagation();
        if (drawer && drawer.open) drawer.close();
        widget.click();
      }
      return;
    }

    if (trigger && drawer && window.matchMedia('(max-width:1199px)').matches) {
      event.preventDefault();
      event.stopImmediatePropagation();
      if (drawer.open) { drawer.close(); return; }
      opener = trigger;
      previousOverflow = document.documentElement.style.overflow;
      document.documentElement.style.overflow = 'hidden';
      trigger.setAttribute('aria-expanded', 'true');
      trigger.setAttribute('aria-controls', drawer.id);
      showPanel(drawer, 'ella-categories-root', false);
      drawer.showModal();
      return;
    }
    if (!drawer || !drawer.open) return;
    if (drawer.contains(event.target)) event.stopImmediatePropagation();
    if (event.target.closest('.ella-drawer-close')) { drawer.close(); return; }
    const panelButton = event.target.closest('[data-panel]');
    if (panelButton && drawer.contains(panelButton)) showPanel(drawer, panelButton.dataset.panel, true);
    if (event.target === drawer) {
      const rect = drawer.getBoundingClientRect();
      if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) drawer.close();
    }
  }, true);
  document.addEventListener('close', event => {
    if (event.target.id !== 'EllaCategoryDrawer') return;
    document.documentElement.style.overflow = previousOverflow || '';
    if (opener) { opener.setAttribute('aria-expanded', 'false'); opener.focus(); }
  }, true);
  window.addEventListener('resize', () => {
    const drawer = getDrawer();
    if (drawer && drawer.open && window.innerWidth > 1199) drawer.close();
  });
})();

(() => {
  let attempts = 0;
  const setupCookieLinks = () => {
    const root = document.querySelector('pandectes-cmp')?.shadowRoot;
    if (!root) return false;
    if (!root.querySelector('button.widget')) {
      const observer = new MutationObserver(() => {
        if (root.querySelector('button.widget')) {
          observer.disconnect();
          setupCookieLinks();
        }
      });
      observer.observe(root, { childList: true, subtree: true });
      return true;
    }
    const configure = link => {
      link.href = '#cookie-settings';
      link.textContent = 'Cookie-Einstellungen';
      link.setAttribute('data-ella-cookie-settings', '');
      link.setAttribute('aria-haspopup', 'dialog');
      link.style.fontFamily = 'Roboto,Arial,sans-serif';
    };
    document.querySelectorAll('a[href="/pages/cookies"]').forEach(configure);
    document.querySelectorAll('.ella-drawer-row[href="/pages/kontakt"], .slide-nav__link[href="/pages/kontakt"], .megamenu__col-title a[href="/pages/kontakt"]').forEach(contact => {
      const item = contact.parentElement;
      if (item.parentElement.querySelector('[data-ella-cookie-settings]')) return;
      const copy = item.cloneNode(true);
      configure(copy.querySelector('a'));
      item.after(copy);
    });
    const footerLink = document.querySelector('footer [data-ella-cookie-settings], .site-footer [data-ella-cookie-settings]');
    if (!footerLink) return false;
    if (!root.querySelector('#ella-cookie-position')) {
      const style = document.createElement('style');
      style.id = 'ella-cookie-position';
      style.textContent = 'button.widget{display:none!important}';
      root.appendChild(style);
    }
    return true;
  };
  if (!setupCookieLinks()) {
    const timer = setInterval(() => {
      attempts += 1;
      if (setupCookieLinks() || attempts >= 120) clearInterval(timer);
    }, 500);
  }
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ella-category-mega"] && !Shopify.designMode) return;
  try {
    (() => {
  let restoringFocus = false;
  const pending = new WeakMap();
  const cancel = menu => {
    clearTimeout(pending.get(menu));
    pending.delete(menu);
  };
  const close = menu => {
    cancel(menu);
    menu.querySelectorAll('[data-ella-flyout-row]').forEach(row => {
      row.classList.remove('is-active');
      row.querySelector('.ella-desktop-category__toggle').setAttribute('aria-expanded', 'false');
      row.querySelector('.ella-desktop-category__panel').hidden = true;
    });
  };
  const open = row => {
    const menu = row.closest('.ella-compact-dropdown');
    close(menu);
    menu.classList.toggle('ella-flyout-left', menu.getBoundingClientRect().right + 330 > window.innerWidth - 16);
    row.classList.add('is-active');
    row.querySelector('.ella-desktop-category__toggle').setAttribute('aria-expanded', 'true');
    row.querySelector('.ella-desktop-category__panel').hidden = false;
  };
  document.addEventListener('pointerover', event => {
    if (event.pointerType === 'touch') return;
    const row = event.target.closest('.ella-desktop-category');
    const menu = event.target.closest('.ella-compact-dropdown');
    if (!menu || !window.matchMedia('(min-width:769px)').matches) return;
    if (!menu.contains(event.relatedTarget) || event.target.closest('.ella-desktop-category__panel')) cancel(menu);
    if (!row || row.contains(event.relatedTarget)) return;
    cancel(menu);
    const activate = () => {
      if (row.hasAttribute('data-ella-flyout-row')) open(row);
      else close(menu);
    };
    if (menu.querySelector('.ella-desktop-category.is-active') && !row.classList.contains('is-active')) {
      pending.set(menu, setTimeout(activate, 250));
    } else activate();
  });
  document.addEventListener('focusin', event => {
    if (restoringFocus) return;
    const row = event.target.closest('[data-ella-flyout-row]');
    if (row && !event.target.closest('.ella-desktop-category__panel')) open(row);
  });
  document.addEventListener('click', event => {
    const button = event.target.closest('.ella-desktop-category__toggle');
    if (button) {
      event.preventDefault();
      event.stopPropagation();
      open(button.closest('[data-ella-flyout-row]'));
    } else if (!event.target.closest('.ella-compact-dropdown')) {
      document.querySelectorAll('.ella-compact-dropdown').forEach(close);
    }
  });
  document.addEventListener('keydown', event => {
    const row = event.target.closest('[data-ella-flyout-row]');
    if (!row) return;
    const panel = row.querySelector('.ella-desktop-category__panel');
    if (event.key === 'ArrowRight' && !panel.contains(event.target)) {
      event.preventDefault();
      open(row);
      panel.querySelector('a').focus();
    } else if ((event.key === 'Escape' || event.key === 'ArrowLeft') && !panel.hidden) {
      event.preventDefault();
      event.stopPropagation();
      close(row.closest('.ella-compact-dropdown'));
      restoringFocus = true;
      row.querySelector('button').focus();
      restoringFocus = false;
    }
  });
  document.addEventListener('pointerout', event => {
    const menu = event.target.closest('.ella-compact-dropdown');
    if (event.pointerType !== 'touch' && menu && !menu.contains(event.relatedTarget)) {
      cancel(menu);
      pending.set(menu, setTimeout(() => close(menu), 300));
    }
  });
  document.addEventListener('focusout', event => {
    const menu = event.target.closest('.ella-compact-dropdown');
    if (menu && !menu.contains(event.relatedTarget)) close(menu);
  });
})();
  } catch(e) { console.error(e); }
})();

})();
